import React from 'react'
import PropTypes from 'prop-types'
import { useApplicationContext } from '../../../../context/ApplicationContext'
import { Message } from '@paypalcorp/worldready-react'

export const TopNavBannerSandbox = ({ label }) => {
  const { enviroment, user } = useApplicationContext()

  return (
    <>
      {enviroment === 'sandbox' && user && (
        <div className="dev_dash__top-nav-banner-sandbox-line">
          <div className="dev_dash__top-nav-banner-sandbox">
            <Message id={label} />
          </div>
        </div>
      )}
    </>
  )
}

TopNavBannerSandbox.propTypes = {
  label: PropTypes.string,
}
